export default __webpack_public_path__ + "static/media/garage2.8b2cfafd.png";